module.exports = __webpack_public_path__ + "img/rose-3.1925595e.png";